import { coverageComboStore } from './coverageComboStore';

export const withIdCoverageCombo = (payload) => ({
  ...payload,
  id_coverage_combo: payload.id_coverage_combo ?? coverageComboStore.getId(),
});

export const getSanitizedCoverageRest = (dataCoverage) => {
  const { optional_coverages, ...rest } = dataCoverage;
  const sanitizedRest = { ...rest };

  for (const item in sanitizedRest) {
    if (sanitizedRest[item] === undefined) {
      delete sanitizedRest[item];
    }
  }

  const optionals = optional_coverages ? Object.values(optional_coverages) : [];
  const optionalsCoverages = optionals.filter((value) => value !== undefined);

  return { rest: sanitizedRest, optionalsCoverages };
};

export const buildQuotationCoveragePayload = ({
  quotationData,
  rest,
  optionalsCoverages,
  commissionPayloadValue,
  percentDiscount,
  discount_percent,
  policy_modality,
  installments,
  shouldUseAnnualInstallments,
  productIds,
}) =>
  withIdCoverageCombo({
    cep: quotationData.address.zip_code,
    value: quotationData.vehicle.value,
    year_model: Number(quotationData.vehicle.year_model),
    year_manufacture: Number(quotationData.vehicle.build_year),
    id_use: quotationData.vehicle.id_vehicle_use,
    brand: quotationData.vehicle.id_brand,
    fipe_code: quotationData.vehicle.fipe_code,
    from_auction: quotationData.vehicle.auction,
    ...rest,
    has_gnv: quotationData.vehicle.gnv,
    zero_km: quotationData.vehicle.zero_km,
    eletric_hybridValue: false,
    some_driver_18_25_years_old: quotationData.quotationProposalData.under25,
    optional_coverages: optionalsCoverages,
    grievance_percent: commissionPayloadValue,
    discount_percent: percentDiscount > 0 ? (percentDiscount * discount_percent) / 100 : 0,
    policy_modality: policy_modality ?? quotationData?.policy_modality,
    installments: shouldUseAnnualInstallments && installments ? installments : undefined,
    ...(productIds !== undefined ? { products: productIds } : {}),
  });
